import { shadow } from "./shadow";

const vieweratiCss = `
  .paragraph {
    text-wrap: pretty;
  }

  .shadow { ${shadow()} }
  align-items: center;
  display: grid;
  justify-items:  center;
 

  .inkReveal {
    mask-image: url(/fx/ink_lv2.gif);
    mask-size: cover;
    mask-position: center;
  }

  @keyframes fadeIn {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }

  .animate  { animation: fadeIn 5s; }

  .disable-select {
    user-select: none;
    /* supported by Chrome and Opera */
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-user-select: none;
    /* Safari */
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -khtml-user-select: none;
    /* Konqueror HTML */
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -moz-user-select: none;
    /* Firefox */
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -ms-user-select: none;
    /* Internet Explorer/Edge */
  }




  /*for screen readers*/
  .sr-only {
    position: absolute;
    left: -10000px;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
  }

  .text-modifier.__{
    text-decoration: underline;
  }

  .neuro-divergent-sentence {
    display: flex;
    flex-wrap: wrap;
  }

  .neuro-divergent-letter-bold {
    font-weight: bold;
  }   `;

export default vieweratiCss;
